import React from 'react';
import { FormattedDate } from 'react-intl';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { InputButton } from '@vio/atlas/helpers/InputButton';
import { Icon } from '@vio/atlas/Icon';
import isValidDate from 'date-fns/isValid';
import { FormattedMessageWrapper } from '@daedalus/core/src/localization/components/FormattedMessage';
import { MiddayDate } from '@daedalus/core/src/utils/date';
import { guestPickerMessages } from '../GuestPicker/guestPickerMessages';
interface Props {
  /** Check in date */
  checkIn: MiddayDate;
  /** Check out date */
  checkOut: MiddayDate;
  /** Destination name */
  destination: React.ReactNode;
  /** Number of guests */
  numberOfGuests: number;
  /** Number of rooms */
  numberOfRooms: number;
  /** Click callback */
  onClick: () => void;
  /** Whether to show the compacted variant */
  isCompact?: boolean;
  /** Whether the rooms count and label is shown */
  isRoomsLabelShown?: boolean;
  /** Whether the Summary Button is rounded */
  isRounded?: boolean;
  /** Whether the color used for borders and icons is the default or neutral */
  isNeutralColor?: boolean;
  /** Whether the button is used in the new search bar */
  isNewSearchSummary?: boolean; // Added as part of 1c5ad789-mobile-top-bar
}
const _exp = /*#__PURE__*/() => InputButton;
const SummaryButton = /*#__PURE__*/styled(_exp())({
  name: "SummaryButton",
  class: "s399y79",
  propsAsIs: true
});
const Wrapper = /*#__PURE__*/styled('span')({
  name: "Wrapper",
  class: "w9e75ga",
  propsAsIs: false
});
const DestinationText = /*#__PURE__*/styled('span')({
  name: "DestinationText",
  class: "d1256cu3",
  propsAsIs: false
});
const GuestsDateWrapper = /*#__PURE__*/styled('span')({
  name: "GuestsDateWrapper",
  class: "g1q7fpp9",
  propsAsIs: false
});
const CompactBullet = /*#__PURE__*/styled('span')({
  name: "CompactBullet",
  class: "c1tfx3sc",
  propsAsIs: false
});
const ShortFormattedDate = ({
  value
}: {
  value: Date;
}): React.ReactElement => <FormattedDate value={value} month="short" day="2-digit" timeZone="UTC" />;
export const SearchSummaryButton = ({
  destination,
  checkIn,
  checkOut,
  numberOfGuests,
  numberOfRooms,
  onClick,
  isCompact = false,
  isRoomsLabelShown = true,
  isRounded = true,
  isNeutralColor = false,
  isNewSearchSummary = false // Added as part of 1c5ad789-mobile-top-bar
}: Props) => {
  const isDatesValid = isValidDate(checkIn) && isValidDate(checkOut);
  return <SummaryButton id="SearchSummary" onClick={onClick} dataId="SearchSummary" className={cx(isCompact && 'isCompact', isNeutralColor && 'isNeutralColor', isNewSearchSummary && '__newSearchSummary' // Added as part of 1c5ad789-mobile-top-bar
  )} icon={<Icon name="Search" size="md" colorPath={isNeutralColor ? undefined : 'content.interactive.c700'} />} isRounded={isRounded}>
      <Wrapper className={cx(isCompact && 'isCompact', isNewSearchSummary && '__newSearchSummary' // Added as part of 1c5ad789-mobile-top-bar
    )}>
        <DestinationText data-id="DestinationValue" className={cx(isNewSearchSummary && !isCompact && '__newSearchSummary' // Added as part of 1c5ad789-mobile-top-bar
      )}>
          {destination || <FormattedMessageWrapper id="whereAreYouGoing" defaultMessage="Where are you going?" />}
        </DestinationText>

        {isCompact && <CompactBullet>{'\u00A0·\u00A0'}</CompactBullet>}

        {isDatesValid && <GuestsDateWrapper className={cx(isCompact && 'isCompact', 'chromatic-ignore')}>
            <span data-id="CheckInValue">
              <ShortFormattedDate value={checkIn} />
            </span>
            {' - '}
            <span data-id="CheckOutValue">
              <ShortFormattedDate value={checkOut} />
            </span>
            {!isCompact && <>
                <span data-id="GuestValue">{' · '}</span>
                <FormattedMessageWrapper {...guestPickerMessages.guest} values={{
            count: numberOfGuests
          }} />
                {isRoomsLabelShown && <>
                    <span data-id="RoomValue">{', '}</span>
                    <FormattedMessageWrapper {...guestPickerMessages.room} values={{
              count: numberOfRooms
            }} />
                  </>}
              </>}
          </GuestsDateWrapper>}
      </Wrapper>
    </SummaryButton>;
};

require("./SearchSummaryButton.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SearchSummaryButton.tsx");